import { property } from 'lit/decorators.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const AnchorElementMixin = (superClass) => {
  class AnchorElement extends superClass {
    get isAnchor() {
      return this.href !== void 0;
    }
  }
  __decorateClass([
    property()
  ], AnchorElement.prototype, "href");
  __decorateClass([
    property()
  ], AnchorElement.prototype, "target");
  return AnchorElement;
};

export { AnchorElementMixin };
